export default __webpack_public_path__ + "static/media/Top-Image.a88f2896.png";